import { render, staticRenderFns } from "./AdminLogo.vue?vue&type=template&id=5396a01f"
import script from "./AdminLogo.vue?vue&type=script&lang=js"
export * from "./AdminLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports